// import React from "react";
// import  ReactDOM  from "react-dom";
// import { StrictMode } from "react";
// import { createRoot } from "react-dom/client";

// import App from './App';
// import './index.css';

// ReactDOM.render(
// <React.StrictMode>
// <App/>
// </React.StrictMode>, document.getElementById('root')

// );


import React from 'react';

import './index.css';
import App from './App';


import { createRoot } from 'react-dom/client';
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<React.StrictMode>
  <App />
</React.StrictMode>);

